import { render, staticRenderFns } from "./ConfigPaymentStatus.vue?vue&type=template&id=6e359835&"
import script from "./ConfigPaymentStatus.vue?vue&type=script&lang=js&"
export * from "./ConfigPaymentStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports